import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import AppContext from "../../pages/app/context";
import api from "../../services/api";

import { CircularProgress } from "@mui/material";

import { mergeParams } from "../../helpers/helpers";
import ActionTable from "../../components/table/ActionTable";

export default function Lista({ history, location }) {
  const [filtros, setFiltros] = useState(
    mergeParams({ produto: 0, palavraChave: "", exibirInativos: false }, location)
  );
  const [materiais, setMateriais] = useState([]);
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    listarMateriais();
  }, []);

  const listarMateriais = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    setCarregando(true);
    api
      .get("materiais/listar", filtrosEnviar)
      .then((materiais) => {
        materiais.forEach((m) => {
          m.categoria = m.categoriaNome ? m.categoriaNome : "";
          m.subcategoria = m.subcategoriaNome ? m.subcategoriaNome : "";

          if (m.cicloId) {
            m.produto = `Bilíngue (Ciclo ${m.cicloNumero})`;
          }

          if (m.udtNivelId) {
            m.produto = `Uni-Dune-Tê (Nível ${m.udtNivelNumero})`;
          }
        });

        setMateriais(materiais);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Não foi possível listar as categorias");
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      produto: {
        label: "Produto",
        type: "select",
        emptyItem: true,
        emptyItemText: "(Todos)",
        space: 5,
        options: [
          {
            value: 1,
            desc: "Bilíngue",
          },
          {
            value: 2,
            desc: "Uni Dune Tê",
          },
        ],
        value: filtros.produto,
      },
      palavraChave: {
        label: "Nome/Categoria/Subcategoria",
        type: "text",
        space: 5,
        value: filtros.palavraChave,
      },
      exibirInativos: {
        label: "Exibir inativos",
        type: "check",
        space: 2,
        value: filtros.exibirInativos,
      },
    },
    submit: {
      label: "Buscar",
      action: listarMateriais,
    },
    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Materiais",
    newItemAction: () => history.push("/app/material/0"),
    onLineClick: (material) => history.push(`/app/material/${material.id}`),
    columns: [
      {
        label: "Produto",
        name: "produto",
      },
      {
        label: "Nome",
        name: "nome",
      },
      {
        label: "Categoria",
        name: "categoria",
      },
      {
        label: "Subcategoria",
        name: "subcategoria",
      },
    ],
    array: materiais,
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
